// removed by extract-text-webpack-plugin
module.exports = {"contentContainer":"dashboard__contentContainer___1blaY","navDrawer":"dashboard__navDrawer___2KGF1","panel":"dashboard__panel___3HTxh","nav":"dashboard__nav___6M3Ek","itemContainer":"dashboard__itemContainer___226es","itemContainerActive":"dashboard__itemContainerActive___1tKXt","itemIconContainer":"dashboard__itemIconContainer___qR_fK","itemLabelContainer":"dashboard__itemLabelContainer___3XU3W","itemLabel":"dashboard__itemLabel___Ibj9Q","statusText":"dashboard__statusText___22EY1"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/dashboard/dashboard.css
// module id = 1205
// module chunks = 0